module.exports = __webpack_public_path__ + "static/android-icon-192x192-af727cc2392e864c9ba1681901933723.png";